import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let DropdownComp;

class Dropdown extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: DropdownComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(import(
      /* webpackChunkName: "components/javascript/zcat-components/dropdown-comp" */
      "../../../components/javascript/zcat-components/dropdown-comp"
    ).then(function(res) {
      DropdownComp = res.DropdownComp;
    }));

    
;
  }
}

export { Dropdown };
